import React from 'react';
import { ScrollView, ImageBackground, Text, View, Image } from 'react-native';
import Header from '../../components/Header/Header.web';
import Colette from '../../assets/images/colette.jpg';
import CreateEvent from '../../assets/images/create-event.jpg';
import Earnings from '../../assets/images/earnings.jpg';
import Pottery from '../../assets/images/pottery.jpg';
import Payout from '../../assets/images/payout.jpg';
import Chat from '../../assets/images/chat.jpg';
import NotifyCustomers from '../../assets/images/notify-customers.jpg';
import { H1, H2 } from '../../components/UI/TextStyles';
import Section from '../../components/sections/Section';
import Footer from '../../components/footer/Footer';
import TiltedImageLayout from '../../components/layouts/TiltedImageLayout';
import { isRowLayout } from '../../utilities/screen';
import { Button } from '../../components';
import { useHistory } from 'react-router-dom';

function BecomeAHost() {
  const history = useHistory();
  const StageContent = (
    <View>
      <H1>Verdiene Geld mit deinem Hobby.</H1>
      <p style={{ fontSize: 'x-large' }}>
        Bessere dein Budget auf mit dem, was dir Spass macht. Jetzt
        Triff-Gastgeber werden.
      </p>
      <Button text="Jetzt loslegen" action={() => history.push('/register')} />
    </View>
  );
  const Stage = (
    <ImageBackground
      source={Colette}
      style={{
        minHeight: isRowLayout ? '90vh' : '50vh',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <Section>
        <View
          style={{
            maxWidth: 500,
            width: '100%',
            padding: 30,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderRadius: 10,
            alignItems: 'flex-start',
          }}
        >
          {StageContent}
        </View>
      </Section>
    </ImageBackground>
  );
  return (
    <ScrollView>
      <Header />
      {isRowLayout ? (
        Stage
      ) : (
        <View>
          <Image source={Colette} style={{ width: '100%', height: '40vh' }} />
          <Section>{StageContent}</Section>
        </View>
      )}
      <TiltedImageLayout image={CreateEvent}>
        <h2>Einfach anbieten.</h2>
        <p style={{ fontSize: 'large' }}>
          Ob zuhause für Gäste kochen, einen Töpferkurs anbieten oder eine
          Wandertour organisieren: Mit Triff kannst du einfach loslegen. Ohne
          administrativen Aufwand, ohne Bewerbung, ohne Bürokratie.
        </p>
      </TiltedImageLayout>
      <TiltedImageLayout reverse image={Earnings}>
        <h2>Wir kümmern uns ums Geld.</h2>
        <p style={{ fontSize: 'large' }}>
          Du wählst, wie deine Teilnehmer bezahlen: Ob per Fixpreis oder per
          digitaler Kollekte*. Und wir kümmern uns darum, dass das Geld bei dir
          landet. Denn alle Teilnehmer bezahlen direkt per App. Ohne dass du
          etwas Zusätzliches machen musst.
        </p>
        <small style={{ opacity: 0.5 }}>
          *Hierbei fallen Gebühren an: Bei Angeboten mit Fixpreis beträgt unsere
          Service-Gebühr 15% des Gesamtbetrags, bei Angeboten mit Kollekte 7.5%
          des Gesamtbetrags.
        </small>
      </TiltedImageLayout>
      <TiltedImageLayout image={Chat}>
        <h2>Einfaches An- und Abmelden</h2>
        <p style={{ fontSize: 'large' }}>
          Dank Triff hast du jederzeit den Überblick, wer an deinem Angebot
          teilnimmt. Bei An- und Abmeldungen wirst du per Push-Nachricht
          informiert. Und falls du das Treffen absagen musst, erreichst du alle
          Teilnehmer bequem per Gruppenchat.
        </p>
      </TiltedImageLayout>
      <TiltedImageLayout reverse image={Payout}>
        <h2>Per Knopfdruck auszahlen lassen</h2>
        <p style={{ fontSize: 'large' }}>
          Deine Einnahmen kannst du dir jederzeit ganz einfach auf dein
          Bankkonto überweisen lassen.
        </p>
      </TiltedImageLayout>
      <TiltedImageLayout image={NotifyCustomers}>
        <h2>Per Push bei deinen Kunden.</h2>
        <p style={{ fontSize: 'large' }}>
          Verbinde dich mit deinen Kunden, damit sie per Push-Nachricht
          erfahren, wenn du dein nächstes Treffen anbietest.
        </p>
      </TiltedImageLayout>
      <ImageBackground source={Pottery}>
        <Section
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '80vh',
          }}
        >
          <H2 centered style={{ color: 'white', fontSize: 60 }}>
            Jetzt loslegen.
          </H2>
          <Button
            style={{ margin: 30 }}
            text="Konto erstellen"
            action={() => history.push('/register')}
            size="large"
          />
        </Section>
      </ImageBackground>
      <Footer />
    </ScrollView>
  );
}

export default BecomeAHost;
